/** @format */

import { useSelector } from "react-redux";
import AppContainer from "./App.redux";
import React, { useEffect } from "react";
import { IAppPropsStore } from "../redux/appPropsReducer/types";
import { IRootStore } from "../redux";
import { getAppEnvironment, toAbsoluteUrl } from "../services/UtilityService";

function App() {
	const info = useSelector((state: IRootStore) => state.appPropsStore);

	useEffect(() => {
		let link = document.querySelector(
			"link[rel~='icon']"
		) as HTMLLinkElement;
		if (!link) {
			link = document.createElement("link");
			link.rel = "icon";
			document.getElementsByTagName("head")[0].appendChild(link);
		}
		const environment = getAppEnvironment();

		const faviconURL = (() => {
			
			switch (environment) {
				case "production":
					return toAbsoluteUrl(
						"/favicons/favicon-prod.ico"
					);
				case "QA":
					return toAbsoluteUrl("/favicons/favicon-qa.ico");
				case "development":
					return toAbsoluteUrl("/favicons/favicon-dev.ico");
				default:
					return toAbsoluteUrl(
						"/favicons/favicon-prod.ico"
					);
			}
			
		})();
		link.href = faviconURL;
	}, []);

	return (
		<>{info.voiceGainServerUrl == "" ? <div>loading</div> : <AppContainer />}</>
	);
}

export default App;
